import React, {useMemo} from 'react';
import {Table, Button, Dropdown, Input, Grid, Icon} from 'semantic-ui-react';
import {useTable, usePagination, useFilters} from 'react-table';
import {pageSizes} from '../../../common/constants/lists';
import {Filter, DefaultColumnFilter} from './couriersTableFilters';

const CouriersTable = ({tableColumns, tableData, courierRowClickHandler, courierSelectedToEdit, setCourierRef,
  editCourier, getCourierEditingValue, handleCourierValue, handleDeleteCourier, handleCourierUpdate, addCourier,
  cancelCourierUpdate, changeNewCourierValue, saveNewCourier, cancelAddCourier, courierSelected,
  validateCourier}) => {
  const data = useMemo(() => tableData, [tableData]);
  const columns = useMemo(() => tableColumns, []);

  const TablePaginator = ({
    page,
    canPreviousPage,
    pageIndex,
    pageOptions,
    pageSize,
    canNextPage,
    nextPage,
    gotoPage,
    previousPage,
    setPageSize,
  }) => {
    if (page.length) {
      return (
        <Grid className="pagination">
          <Grid.Row>
            <Grid.Column width={4} textAlign="left">
              <Button
                className="navigation-button"
                onClick={() => previousPage()}
                disabled={!canPreviousPage}
                content="Anterior"
              />
            </Grid.Column>
            <Grid.Column width={4} textAlign="right">
              <span>páginas </span>
              <span>
                <Input
                  className="pages-input"
                  type="number"
                  value={pageIndex + 1}
                  min="1"
                  max={pageOptions.length}
                  onChange={(e, {value}) => {
                    const page = value ? Number(value) - 1 : 0;
                    if (page < 1 || page > pageOptions.length) {
                      e.target.value = 1;
                    }
                    gotoPage(page);
                  }}
                />
              </span>{' '}
              <span>de {pageOptions.length}</span>
            </Grid.Column>
            <Grid.Column width={4} textAlign="left">
              <Dropdown
                className="page-sizes-selection"
                selection
                upward
                compact
                value={pageSize}
                options={pageSizes}
                onChange={(e, {value}) => {
                  setPageSize(Number(value));
                }}
              />
              <span> filas</span>
            </Grid.Column>
            <Grid.Column width={4} textAlign="right">
              <Button
                className="navigation-button"
                onClick={() => nextPage()}
                disabled={!canNextPage}
                content="Siguiente"
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      );
    }
    return null;
  };

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    'state': {pageIndex, pageSize},
  } = useTable(
    {
      columns,
      data,
      'defaultColumn': {'Filter': DefaultColumnFilter},
      'initialState': {'pageIndex': 0, 'pageSize': 5},
      'autoResetFilters': false,
    },
    useFilters,
    usePagination,

    (hooks) => {
      hooks.visibleColumns.push((columns, i) => [
        ...columns.map((column, i) => {
          return {...column,
            'Cell': (item) => {
              return (
                <div key={`body-cell${i}`} style={{'textAlign': 'center'}}>
                  {!courierSelectedToEdit(item.row.original) ?
                    <div>{item.value}</div> :
                    <Input fluid className='' value={getCourierEditingValue(item.cell.column.id)}
                      ref={setCourierRef}
                      id={item.cell.column.id}
                      onChange={(e, input) => handleCourierValue(e, input)} />}
                </div>
              );
            },
          };
        }),
        {
          'id': 'editCourierButton',
          'width': 1,
          'Cell': ({row}) => {
            return (
              <div key={`body-cell${i}`} className='flex end'>
                {!courierSelectedToEdit(row.original) ?
                  <>
                    <Icon name='pencil' link size='big'
                      onClick={(e, input) => editCourier(e, row.original, 'add')} />
                    <Icon name='trash' link size='big' color='red'
                      onClick={(e) => handleDeleteCourier(e, true, row.original)} />
                  </> :
                  <>
                    <Icon name='save' color='green' link size='big' disabled={validateCourier('edit')}
                      onClick={(e, input) => handleCourierUpdate()} />
                    <Icon name='cancel' color='red' link size='big'
                      onClick={(e, input) => cancelCourierUpdate()} />
                  </>
                }
              </div>
            );
          },
        },
      ]);
    }
  );

  return (
    <>
      <Table className='interactive' striped compact {...getTableProps()}>
        <Table.Header>
          {headerGroups.map((headerGroup, i) => (
            <Table.Row key={`headers-${i}`} {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column, index) => (
                <Table.HeaderCell
                  key={`title-${index}`}
                  textAlign='center'
                  width={column.width}
                  {...column.getHeaderProps()}
                >
                  {column.render('Header')}
                </Table.HeaderCell>
              ))}
            </Table.Row>
          ))}
          {headerGroups.map((headerGroup, i) => (
            <>
              <Table.Row key={`filters-${i}`} id='filters'>
                {headerGroup.headers.map((column, i) => (
                  <Table.HeaderCell
                    key={`filter-${i}`}
                    textAlign='center'
                    width={column.width}
                  >
                    {<Filter column={column} />}
                  </Table.HeaderCell>
                ))}
              </Table.Row>
              {addCourier ?
                <Table.Row key={`new-register${i}`} id='new-register'>
                  {headerGroup.headers.map((column, index) => (
                    <Table.HeaderCell
                      style={{'backgroundColor': 'white'}}
                      key={`filter-${index}`}
                      textAlign='center'
                    >
                      {!(column.id === 'editCourierButton') ?
                        <Input fluid disabled={column.id === 'courierName'}
                          value={addCourier[column.id] || ''}
                          onChange={(e, input) => {
                            changeNewCourierValue(e, column, input.value);
                          }}
                        /> :
                        <>
                          <Icon name='save' color='green' link size='big' disabled={validateCourier('add')}
                            onClick={(e) => saveNewCourier(e)} />
                          <Icon name='cancel' color='red' link size='big'
                            onClick={(e) => cancelAddCourier(e)} />
                        </>
                      }
                    </Table.HeaderCell>
                  ))}
                </Table.Row> : ''
              }
            </>
          ))}
        </Table.Header>
        <Table.Body {...getTableBodyProps()}>
          {!page.length && (
            <Table.Row>
              <Table.Cell colSpan={7} textAlign='center'>
                No hay datos disponibles
              </Table.Cell>
            </Table.Row>
          )}
          {page.length > 0 &&
            page.map((row, i) => {
              prepareRow(row);
              const selectedRowStyles = courierSelected && courierSelected.ruc === row.values.ruc ?
                {'cursor': 'pointer', 'backgroundColor': 'yellow'} : {'cursor': 'pointer'};
              return (
                <Table.Row key={i} {...row.getRowProps()} style={selectedRowStyles}>
                  {row.cells.map((cell) => {
                    return cell.column.id === 'editCourierButton' ?
                      <Table.Cell textAlign='center' {...cell.getCellProps()}>
                        {cell.render('Cell')}
                      </Table.Cell> :
                      courierSelectedToEdit(row.original) ?
                        <Table.Cell textAlign='center' {...cell.getCellProps()}>
                          {cell.render('Cell')}
                        </Table.Cell> :
                        <Table.Cell textAlign='center' {...cell.getCellProps()}
                          onClick={(e) => courierRowClickHandler(e, row.values)}>
                          {cell.render('Cell')}
                        </Table.Cell>;
                  })}
                </Table.Row>
              );
            })}
        </Table.Body>
      </Table>
      <TablePaginator
        page={page}
        canPreviousPage={canPreviousPage}
        pageIndex={pageIndex}
        pageOptions={pageOptions}
        pageSize={pageSize}
        canNextPage={canNextPage}
        nextPage={nextPage}
        gotoPage={gotoPage}
        previousPage={previousPage}
        setPageSize={setPageSize}
      />
    </>
  );
};

export default CouriersTable;
